import FeedbackForm from "@/components/feedback/feedback-form";
import { useLocalSearchParams } from "expo-router";
import Drawer from "expo-router/drawer";
import { Text } from "react-native";
import { KeyboardAwareScrollView, KeyboardToolbar } from "react-native-keyboard-controller";


export default function FeedbackPage() {
  const { crewId, query } = useLocalSearchParams();


  return (
    <>
      <Drawer.Screen
        options={{
          title: 'Feedback',
        }}
      />
      <KeyboardAwareScrollView
        bottomOffset={62}
        className="flex-1 bg-background p-4"
        contentContainerStyle={{
          gap: 20,
          paddingTop: 40,
        }}
      >
        {query ? <Text className="text-xl text-foreground font-extrabold tracking-tight self-start">Provide feedback for {query}</Text> : null}
        <FeedbackForm jobCrewId={Number(crewId)} crewMemberName={typeof query === 'string' ? query : undefined} />
      </KeyboardAwareScrollView>
      <KeyboardToolbar />
    </>
  )
}